import { render, staticRenderFns } from "./EncuestaAdm.vue?vue&type=template&id=a780aa2e&scoped=true"
import script from "./EncuestaAdm.vue?vue&type=script&lang=js"
export * from "./EncuestaAdm.vue?vue&type=script&lang=js"
import style0 from "./EncuestaAdm.vue?vue&type=style&index=0&id=a780aa2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a780aa2e",
  null
  
)

export default component.exports